<template>
  <div
    v-cloak
    :class="{ 'mobile': !isDesktop, 'premium': user && user.group !== 1 }"
    class="main"
  >
    <Mobile v-if="!isDesktop" />

    <TopPlayer />

    <nav v-if="isDesktop" class="left-menu">
      <Search />

      <ul class="cats">
        <li :class="{active: !$route.params.type }">
          <nuxt-link to="/">
            {{ lang('main', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'radio' }">
          <nuxt-link to="/collection/radio">
            {{ lang('radio', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'genres' }">
          <nuxt-link to="/collection/genres">
            {{ lang('genres', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'collections' }">
          <nuxt-link to="/collection/collections">
            {{ lang('collections', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'charts' }">
          <nuxt-link to="/collection/charts">
            {{ lang('charts', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'albums' }">
          <nuxt-link to="/collection/albums">
            {{ lang('albums', 'ru') }}
          </nuxt-link>
        </li>
        <li :class="{active: $route.params.type === 'artists' }">
          <nuxt-link to="/collection/artists">
            {{ lang('artists', 'ru') }}
          </nuxt-link>
        </li>
      </ul>

      <div class="top-menu">
        <div class="head">
          <!-- <strong>ТОП</strong> -->
          <ul>
            <li @click="setTop('track')" :class="{ active: topMenuCat === 'track' }">ТОП 100</li>
            <li @click="setTop('chart')" :class="{ active: topMenuCat === 'chart' }">Чарты</li>
            <li @click="setTop('collection')" :class="{ active: topMenuCat === 'collection' }">Муз.сборники</li>
            <li @click="setTop('artist')" :class="{ active: topMenuCat === 'artist' }">Исполнители</li>
            <li @click="setTop('album')" :class="{ active: topMenuCat === 'album' }">Альбомы</li>
            <li @click="setTop('genre')" :class="{ active: topMenuCat === 'genre' }">Жанры</li>
          </ul>
        </div>
        <div v-show="topMenuCat === 'track'" class="items track">
          <nuxt-link
            v-for="item in tops['track']"
            :key="`top-track-${item.id}`"
            :to="`/track/${item.id}`"
            class="item"
          >
            <div class="poster">
              <img :src="item.poster" :alt="`track ${item.title}`">
            </div>
            <div>
              <div :class="`progress ${item.progress}`"></div>
              <strong :class="item.progress">{{ item.title }}</strong>
              <span>{{ item.subtitle }}</span>
            </div>
          </nuxt-link>
        </div>
        <div v-show="topMenuCat === 'chart'" class="items">
          <nuxt-link
            v-for="item in tops['chart']"
            :key="`top-chart-${item.id}`"
            :to="item.id"
            class="item"
          >
            <div class="poster">
              <img :src="item.poster" :alt="`chart ${item.title}`">
            </div> 
            <strong>{{ item.title }}</strong>
          </nuxt-link>
        </div>
        <div v-show="topMenuCat === 'artist'" class="items">
          <nuxt-link
            v-for="item in tops['artist']"
            :key="`top-artist-${item.id}`"
            :to="item.id"
            class="item"
          >
            <div class="poster">
              <img :src="item.poster" :alt="`artist ${item.title}`">
            </div> 
            <strong>{{ item.title }}</strong>
          </nuxt-link>
        </div>
        <div v-show="topMenuCat === 'album'" class="items">
          <nuxt-link
            v-for="item in tops['album']"
            :key="`top-album-${item.id}`"
            :to="item.id"
            class="item"
          >
            <div class="poster">
              <img :src="item.poster" :alt="`album ${item.title}`">
            </div> 
            <strong>{{ item.title }}</strong>
          </nuxt-link>
        </div>
        <div v-show="topMenuCat === 'genre'" class="items noposter">
          <nuxt-link
            v-for="item in tops['genre']"
            :key="`top-genre-${item.id}`"
            :to="item.id"
            class="item"
          >
            <strong>{{ item.title }}</strong>
          </nuxt-link>
        </div>
        <div v-show="topMenuCat === 'collection'" class="items">
          <nuxt-link
            v-for="item in tops['collection']"
            :key="`top-collection-${item.id}`"
            :to="item.id"
            class="item"
          >
            <div class="poster">
              <img :src="item.poster" :alt="`collection ${item.title}`">
            </div> 
            <strong>{{ item.title }}</strong>
          </nuxt-link>
        </div>
      </div>

      <div class="profile-menu">
        <div v-if="showProfileMenu" class="profile-menu-panel">
          <div @click="showProfileMenu = false" class="close"></div>
          <div class="item">
            <nuxt-link to="/profile/favs">{{ lang('favorites', 'ru') }}</nuxt-link>
          </div>
          <!-- <div class="item">
            <span @click="logout">{{ lang('logout', 'ru') }}</span>
          </div> -->
        </div>

        <div style="margin-bottom: 15px;">
          <strong @click="showProfileMenu = !showProfileMenu">{{ lang('profile', 'ru' )}}</strong>
        </div>

        <div>
          <a href="mailto:support@muzzilka.ru">support@muzzilka.ru</a>
        </div>
      </div>
    </nav>

    <nuxt class="content" />

    <!-- <div v-if="gloading" class="gloading">
      <div class="icon"></div>
      <span>Загрузка трэка {{ glCounter >= 1 ? glCounter + ' сек...' : '...еще немного' }}</span>
    </div> -->

    <transition name="toBottom">
      <Error v-if="error" :error="error" />
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import global from '~/mixins/global.js'

Vue.mixin(global)

export default {
  components: {
    Error: () => import('~/components/Error.vue'),
    Search: () => import('~/components/Search.vue'),
    TopPlayer: () => import('~/components/TopPlayer.vue'),
    Mobile: () => import('~/components/Mobile.vue'),
  },
  computed: {
    ...mapState(['error', 'isDesktop', 'user', 'gloading']),
    changeRoute() {
      return this.$route.fullPath
    },
  },
  watch: {
    gloading(val) {
      if (val) {
        if (this.glCounter > 1) {
          this.glInterval = setInterval(() => {
            --this.glCounter
          }, 1000)
        } else {
          clearInterval(this.glInterval)
        }
      } else {
        clearInterval(this.glInterval)
        this.glCounter = 5
      }
    },
    changeRoute() {
      this.showProfileMenu = false
    },
  },
  data() {
    return {
      showProfileMenu: false,
      glCounter: 5,
      glInterval: null,
      topMenuCat: 'track',
      tops: {
        track: [{"id":"78048684","poster":"https://static.hitmcdn.com/covers/a/677/88a/832117.jpg","tracks":["78048684"],"progress":"best-track","title":"Асфальт","subtitle":"Jakone, Kiliana"},{"id":"78055583","poster":"https://static.hitmcdn.com/covers/a/563/ddb/832393.jpg","tracks":["78055583"],"progress":"same","title":"Supersonic","subtitle":"Big Baby Tape, Aarne"},{"id":"77620461","poster":"https://static.hitmcdn.com/covers/a/213/a03/818068.jpg","tracks":["77620461"],"progress":"up","title":"Матушка","subtitle":"Татьяна Куртукова"},{"id":"77596364","poster":"https://static.hitmcdn.com/covers/a/731/c02/817332.jpg","tracks":["77596364","77015567","77798645","77953683"],"progress":"down","title":"Поезда","subtitle":"Женя Трофимов, Комната культуры"},{"id":"78009739","poster":"https://static.hitmcdn.com/covers/a/e08/08c/831215.jpg","tracks":["78009739"],"progress":"same","title":"ГЛАМУР","subtitle":"uniqe, nkeeei, ARTEM SHILOVETS, Wipo"},{"id":"77750959","poster":"https://static.hitmcdn.com/covers/a/175/590/822600.jpg","tracks":["77750959"],"progress":"up","title":"Дарите женщинам цветы","subtitle":"Jazzdauren"},{"id":"77840942","poster":"https://static.hitmcdn.com/covers/a/c08/e8e/826462.jpg","tracks":["77840942"],"progress":"down","title":"Селфхарм","subtitle":"Монеточка"},{"id":"77518813","poster":"https://static.hitmcdn.com/covers/a/a43/c3e/814781.jpg","tracks":["77518813"],"progress":"same","title":"Пожары","subtitle":"XOLIDAYBOY"},{"id":"77655061","poster":"https://static.hitmcdn.com/cover/c22/881/47372.jpg","tracks":["77655061","77663956","77814304","77832177"],"progress":"same","title":"Можно я с тобой","subtitle":"DVN"},{"id":"77621078","poster":"https://static.hitmcdn.com/covers/a/81d/c66/818147.jpg","tracks":["77621078"],"progress":"same","title":"Харизма","subtitle":"Wallem"},{"id":"77571227","poster":"https://static.hitmcdn.com/covers/a/343/d02/816453.jpg","tracks":["77571227"],"progress":"up","title":"Последняя Любовь","subtitle":"MORGENSHTERN"},{"id":"77840941","poster":"https://static.hitmcdn.com/covers/a/c08/e8e/826462.jpg","tracks":["77840941"],"progress":"up","title":"Кис Кис Кис","subtitle":"Монеточка"},{"id":"77823165","poster":"https://static.hitmcdn.com/covers/a/68c/858/826002.jpg","tracks":["77823165"],"progress":"down","title":"Мир","subtitle":"Гио Пика, MIRAVI"},{"id":"77546990","poster":"https://static.hitmcdn.com/covers/a/e95/1fd/815704.jpg","tracks":["77546990"],"progress":"up","title":"Были бы крылья","subtitle":"Merab Amzoevi"},{"id":"78055584","poster":"https://static.hitmcdn.com/covers/a/563/ddb/832393.jpg","tracks":["78055584"],"progress":"down","title":"Ameli","subtitle":"Big Baby Tape, Aarne, Toxi$"},{"id":"77534584","poster":"https://static.hitmcdn.com/covers/a/dcb/b2e/815418.jpg","tracks":["77534584"],"progress":"down","title":"Дорога дальняя","subtitle":"Jakone"},{"id":"76368874","poster":"https://static.hitmcdn.com/covers/a/113/de9/783680.jpg","tracks":["76368874"],"progress":"same","title":"Царица","subtitle":"ANNA ASTI"},{"id":"77772743","poster":"https://static.hitmcdn.com/covers/a/d12/fc8/824515.jpg","tracks":["77772743"],"progress":"up","title":"далеко (большой Бушизм) [prod. by wex & heysubr]","subtitle":"BUSHIDO ZHO"},{"id":"77963647","poster":"https://static.hitmcdn.com/covers/a/662/777/830096.jpg","tracks":["77963647"],"progress":"up","title":"Я найду тебя через века","subtitle":"Баста"},{"id":"77868966","poster":"https://static.hitmcdn.com/covers/a/3cb/f51/827923.jpg","tracks":["77868966"],"progress":"down","title":"Про неё","subtitle":"TIGO, Wallem"},{"id":"76710925","poster":"https://static.hitmcdn.com/covers/a/d43/37e/791414.jpg","tracks":["76710925"],"progress":"up","title":"Давай сбежим (Искорки)","subtitle":"5УТРА"},{"id":"62570545","poster":"https://static.hitmcdn.com/covers/a/433/3bd/488389.jpg","tracks":["62570545","75722927","1671691"],"progress":"up","title":"Кукла колдуна","subtitle":"Король и Шут"},{"id":"76854795","poster":"https://static.hitmcdn.com/static/images/no-cover-150.jpg","tracks":["76854795"],"progress":"same","title":"Прощание","subtitle":"Три дня дождя, MONA"},{"id":"78009027","poster":"https://static.hitmcdn.com/covers/a/8f8/c6e/831129.jpg","tracks":["78009027"],"progress":"down","title":"Он тебя целует","subtitle":"Руки Вверх!, ELMAN, MONA"},{"id":"62571704","poster":"https://static.hitmcdn.com/covers/a/661/e89/488471.jpg","tracks":["62571704","48190491","75722919","47992218","28572341","46451330","73192886"],"progress":"up","title":"Лесник","subtitle":"Король и Шут"},{"id":"71680389","poster":"https://static.hitmcdn.com/covers/a/7dd/d31/633759.jpg","tracks":["71680389"],"progress":"down","title":"Пыяла","subtitle":"АИГЕЛ"},{"id":"77933880","poster":"https://static.hitmcdn.com/covers/a/fb7/805/829490.jpg","tracks":["77933880"],"progress":"up","title":"Спокойной ночи","subtitle":"ALBLAK 52, Скриптонит, FRIENDLY THUG 52 NGG"},{"id":"77933021","poster":"https://static.hitmcdn.com/covers/a/4d6/720/829396.jpg","tracks":["77933021"],"progress":"down","title":"ЗА БЫВШЕГО","subtitle":"Люся Чеботина"},{"id":"77840935","poster":"https://static.hitmcdn.com/covers/a/c08/e8e/826462.jpg","tracks":["77840935"],"progress":"up","title":"Это было в России","subtitle":"Монеточка"},{"id":"76227279","poster":"https://static.hitmcdn.com/covers/a/df6/a8e/780880.jpg","tracks":["76227279"],"progress":"down","title":"Не вспоминай","subtitle":"NILETTO, Олег Майами, Лёша Свик"},{"id":"75704918","poster":"https://static.hitmcdn.com/covers/a/b3e/a22/768574.jpg","tracks":["75704918"],"progress":"down","title":"Где прошла ты","subtitle":"Кравц, Гио Пика"},{"id":"75722766","poster":"https://static.hitmcdn.com/covers/a/4c9/44b/769582.jpg","tracks":["75722766"],"progress":"up","title":"ASPHALT 8","subtitle":"MACAN"},{"id":"75899296","poster":"https://static.hitmcdn.com/covers/a/280/48e/772797.jpg","tracks":["75899296"],"progress":"down","title":"По весне","subtitle":"Jakone, SCIRENA"},{"id":"76434312","poster":"https://static.hitmcdn.com/covers/a/e45/cf9/784782.jpg","tracks":["76434312"],"progress":"down","title":"Я плачу","subtitle":"A.V.G"},{"id":"76184867","poster":"https://static.hitmcdn.com/covers/a/bba/d05/780087.jpg","tracks":["76184867"],"progress":"down","title":"Танцы","subtitle":"NLO"},{"id":"76293621","poster":"https://static.hitmcdn.com/covers/a/310/777/782133.jpg","tracks":["76293621"],"progress":"up","title":"+7(952)812","subtitle":"ALBLAK 52"},{"id":"74376135","poster":"https://static.hitmcdn.com/covers/a/e12/a3e/725007.jpg","tracks":["74376135"],"progress":"up","title":"По барам","subtitle":"ANNA ASTI"},{"id":"76523828","poster":"https://static.hitmcdn.com/covers/a/250/d2c/786308.jpg","tracks":["76523828"],"progress":"down","title":"Мания","subtitle":"XOLIDAYBOY"},{"id":"77773475","poster":"https://static.hitmcdn.com/covers/a/561/9a4/824602.jpg","tracks":["77773475"],"progress":"down","title":"ЗАХОТЕЛ","subtitle":"НАВЕРНОЕ ПОЭТ, ЯКОРЪ, EVEN CUTE"},{"id":"75884855","poster":"https://static.hitmcdn.com/covers/a/c25/a8c/772587.jpg","tracks":["75884855"],"progress":"up","title":"Где ты теперь и с кем","subtitle":"Баста, HammAli & Navai"},{"id":"76441299","poster":"https://static.hitmcdn.com/covers/a/e05/50f/784958.jpg","tracks":["76441299"],"progress":"down","title":"Океаны","subtitle":"XOLIDAYBOY"},{"id":"76929092","poster":"https://static.hitmcdn.com/covers/a/fe0/50d/797281.jpg","tracks":["76929092"],"progress":"up","title":"Lost Angeles","subtitle":"FRIENDLY THUG 52 NGG"},{"id":"73044567","poster":"https://static.hitmcdn.com/cover/19c/787/20694.jpg","tracks":["73044567","66904186","66826217"],"progress":"up","title":"На заре","subtitle":"Баста"},{"id":"76631053","poster":"https://static.hitmcdn.com/covers/a/a14/5bf/789715.jpg","tracks":["76631053"],"progress":"up","title":"Она близко","subtitle":"A.V.G, Goro"},{"id":"75297362","poster":"https://static.hitmcdn.com/covers/a/ee3/660/754122.jpg","tracks":["75297362"],"progress":"down","title":"Ветер меняет направление","subtitle":"Моя Мишель"},{"id":"48182429","poster":"https://static.hitmcdn.com/covers/a/b5b/aa9/2559.jpg","tracks":["48182429","73192873","47992222"],"progress":"down","title":"Дурак и молния","subtitle":"Король и Шут"},{"id":"77415377","poster":"https://static.hitmcdn.com/covers/a/89a/4cb/811673.jpg","tracks":["77415377"],"progress":"down","title":"Качели","subtitle":"Artik & Asti"},{"id":"75274869","poster":"https://static.hitmcdn.com/covers/a/e21/01e/753582.jpg","tracks":["75274869"],"progress":"up","title":"Моя хулиганка","subtitle":"XOLIDAYBOY"},{"id":"74140607","poster":"https://static.hitmcdn.com/covers/a/d98/4df/720365.jpg","tracks":["74140607","74972755"],"progress":"up","title":"Отпускай","subtitle":"Три дня дождя"},{"id":"76927955","poster":"https://static.hitmcdn.com/covers/a/69f/96d/797114.jpg","tracks":["76927955"],"progress":"up","title":"Спонсор твоих проблем","subtitle":"GUF, A.V.G"},{"id":"73069250","poster":"https://static.hitmcdn.com/covers/a/744/4c4/674662.jpg","tracks":["73069250"],"progress":"down","title":"Зима в сердце","subtitle":"Моя Мишель"}],
        chart: [
          {
            id: '/collection/charts/top-today',
            poster: 'https://rus.hitmotop.com/android-chrome-512x512.png',
            title: 'TOP-500',
          },
          {
            id: '/collection/charts/10562',
            poster: 'https://static.hitmcdn.com/collection_images/10562/s150.jpg',
            title: 'Europa plus (Европа плюс)',
          },
          {
            id: '/collection/charts/10570',
            poster: 'https://static.hitmcdn.com/collection_images/10570/s150.jpg',
            title: 'Love Радио',
          },
          {
            id: '/collection/charts/10563',
            poster: 'https://static.hitmcdn.com/collection_images/10563/s150.jpg',
            title: 'Муз ТВ',
          },
          {
            id: '/collection/charts/10568',
            poster: 'https://static.hitmcdn.com/collection_images/10568/s150.jpg',
            title: 'Радио Energy',
          },
          {
            id: '/collection/charts/10578',
            poster: 'https://static.hitmcdn.com/collection_images/10578/s150.jpg',
            title: 'Like fm',
          },
          {
            id: '/collection/charts/10572',
            poster: 'https://static.hitmcdn.com/collection_images/10572/s150.jpg',
            title: 'Хит Фм (Хит fm)',
          },
          {
            id: '/collection/charts/10574',
            poster: 'https://static.hitmcdn.com/collection_images/10574/s150.jpg',
            title: 'Радио Рекорд',
          },
        ],
        collection: [
          {
            id: '/collection/collections/9711',
            poster: 'https://static.hitmcdn.com/collection_images/9711/s150.jpg',
            title: 'В сердечке',
          },
          {
            id: '/collection/collections/10749',
            poster: 'https://static.hitmcdn.com/collection_images/10749/s150.jpg',
            title: 'Топ за всё время',
          },
          {
            id: '/collection/collections/9553',
            poster: 'https://static.hitmcdn.com/collection_images/9553/s150.jpg',
            title: 'Популярно в Москве',
          },
          {
            id: '/collection/collections/10420',
            poster: 'https://static.hitmcdn.com/collection_images/10420/s150.jpg',
            title: 'Видеошоты',
          },
          {
            id: '/collection/collections/2720',
            poster: 'https://static.hitmcdn.com/collection_images/2720/s150.jpg',
            title: 'Лучшее: «Король и Шут»',
          },
          {
            id: '/collection/collections/10179',
            poster: 'https://static.hitmcdn.com/collection_images/10179/s150.jpg',
            title: '100 суперхитов',
          },
          {
            id: '/collection/collections/9787',
            poster: 'https://static.hitmcdn.com/collection_images/9787/s150.jpg',
            title: 'Популярно в Санкт-Петербурге',
          },
          {
            id: '/collection/collections/731',
            poster: 'https://static.hitmcdn.com/collection_images/731/s150.jpg',
            title: 'Лучшие песни на «Нашем радио»',
          },
        ],
        album: [
          {
            id: '/collection/albums/488389',
            poster: '//avatars.yandex.net/get-music-content/163479/b3e3efc4.a.7019257-1/150x150',
            title: 'Акустический альбом',
          },
          {
            id: '/collection/albums/728138',
            poster: '//avatars.yandex.net/get-music-content/6447985/458c45a5.a.22820453-1/150x150',
            title: 'Феникс',
          },
          {
            id: '/collection/albums/815918',
            poster: '//avatars.yandex.net/get-music-content/9737237/29c758b7.a.25835363-1/150x150',
            title: 'Можно я с тобой',
          },
          {
            id: '/collection/albums/2138',
            poster: '//avatars.yandex.net/get-music-content/28589/39ec1df4.a.1892786-1/150x150',
            title: 'Седая ночь',
          },
          {
            id: '/collection/albums/768574',
            poster: '//avatars.yandex.net/get-music-content/8871869/e8fbb2a7.a.25163882-1/150x150',
            title: '17 мгновений осени',
          },
          {
            id: '/collection/albums/725007',
            poster: '//avatars.yandex.net/get-music-content/6300975/5e337d5f.a.22655317-1/150x150',
            title: 'По барам',
          },
        ],
        artist: [
          {
            id: '/collection/artists/1701',
            poster: '//avatars.yandex.net/get-music-content/28589/24e096f6.p.41052/100x100',
            title: 'Король и Шут',
          },
          {
            id: '/collection/artists/334958',
            poster: '//avatars.yandex.net/get-music-content/118603/d06d3d71.a.5809785-1/100x100',
            title: 'GAYAZOV$ BROTHER$',
          },
          {
            id: '/collection/artists/584601',
            poster: '//avatars.yandex.net/get-music-content/5579153/cb79d31c.p.15691816/100x100',
            title: 'ANNA ASTI',
          },
          {
            id: '/collection/artists/51432',
            poster: '//avatars.yandex.net/get-music-content/97284/78c90835.a.4040512-1/100x100',
            title: 'Ислам Итляшев',
          },
          {
            id: '/collection/artists/794',
            poster: '//avatars.yandex.net/get-music-content/42108/56c4e9bb.p.431593/100x100',
            title: 'Юра Шатунов',
          },
          {
            id: '/collection/artists/48793',
            poster: '//avatars.yandex.net/get-music-content/38044/2fdb491d.a.3771372-1/100x100',
            title: 'Гио Пика',
          },
          {
            id: '/collection/artists/549625',
            poster: '//avatars.yandex.net/get-music-content/4406810/ee2db8e6.a.13906800-1/100x100',
            title: 'ALEKS ATAMAN',
          },
          {
            id: '/collection/artists/519938',
            poster: '//avatars.yandex.net/get-music-content/2424959/244d5c30.a.12080944-1/100x100',
            title: 'Finik.Finya',
          },
        ],
        genre: [
          {
            id: '/collection/genres/51',
            title: 'Нью-эйдж',
          },
          {
            id: '/collection/genres/59',
            title: 'Медитация',
          },
          {
            id: '/collection/genres/2',
            title: 'Поп',
          },
          {
            id: '/collection/genres/32',
            title: 'Латиноамериканская',
          },
          {
            id: '/collection/genres/39',
            title: 'Джаз',
          },
          {
            id: '/collection/genres/13',
            title: 'Другое',
          },
          {
            id: '/collection/genres/99',
            title: 'Иностранный рэп',
          },
          {
            id: '/collection/genres/6',
            title: 'Рок',
          },
          {
            id: '/collection/genres/8',
            title: 'Электроника',
          },
          {
            id: '/collection/genres/28',
            title: 'Классика',
          },
          {
            id: '/collection/genres/42',
            title: 'Кантри',
          },
          {
            id: '/collection/genres/7',
            title: 'Альтернатива',
          },
          {
            id: '/collection/genres/9',
            title: 'Музыка мира',
          },
          {
            id: '/collection/genres/4',
            title: 'Саундтреки',
          },
          {
            id: '/collection/genres/17',
            title: 'Блюз',
          },
          {
            id: '/collection/genres/16',
            title: 'Лёгкая музыка',
          },
          {
            id: '/collection/genres/101',
            title: 'Иностранная авторская песня',
          },
          {
            id: '/collection/genres/24',
            title: 'Соул',
          },
          {
            id: '/collection/genres/20',
            title: 'Хаус',
          },
          {
            id: '/collection/genres/73',
            title: 'Восточная',
          },
          {
            id: '/collection/genres/194',
            title: 'Эмбиент',
          },
          {
            id: '/collection/genres/11',
            title: 'Танцевальная',
          },
          {
            id: '/collection/genres/5',
            title: 'Эстрада и ретро',
          },
          {
            id: '/collection/genres/33',
            title: 'Лаундж',
          },
          {
            id: '/collection/genres/15',
            title: 'Детская',
          },
          {
            id: '/collection/genres/12',
            title: 'Панк',
          },
          {
            id: '/collection/genres/30',
            title: 'Регги',
          },
          {
            id: '/collection/genres/18',
            title: 'Инди',
          },
          {
            id: '/collection/genres/62',
            title: 'Африканская',
          },
          {
            id: '/collection/genres/19',
            title: 'R&B',
          },
          {
            id: '/collection/genres/55',
            title: 'Экспериментальная',
          },
          {
            id: '/collection/genres/63',
            title: 'Современный',
          },
          {
            id: '/collection/genres/45',
            title: 'Техно',
          },
          {
            id: '/collection/genres/92',
            title: 'Классика',
          },
          {
            id: '/collection/genres/75',
            title: 'Русский рэп',
          },
          {
            id: '/collection/genres/61',
            title: 'Рок-н-ролл',
          },
          {
            id: '/collection/genres/107',
            title: 'Аудиокниги',
          },
          {
            id: '/collection/genres/52',
            title: 'Вокал',
          },
          {
            id: '/collection/genres/70',
            title: 'Традиционный',
          },
          {
            id: '/collection/genres/1',
            title: 'Транс',
          },
          {
            id: '/collection/genres/82',
            title: 'Из фильмов',
          },
          {
            id: '/collection/genres/26',
            title: 'Европейская',
          },
          {
            id: '/collection/genres/50',
            title: 'Прогрессивный рок',
          },
          {
            id: '/collection/genres/88',
            title: 'Русская поп-музыка',
          },
          {
            id: '/collection/genres/36',
            title: 'Спортивная',
          },
          {
            id: '/collection/genres/57',
            title: 'Американская',
          },
          {
            id: '/collection/genres/43',
            title: 'Реггетон',
          },
          {
            id: '/collection/genres/97',
            title: 'Экстрим',
          },
          {
            id: '/collection/genres/76',
            title: 'Русский рок',
          },
          {
            id: '/collection/genres/87',
            title: 'Русская',
          },
          {
            id: '/collection/genres/31',
            title: 'Драм-н-бэйс',
          },
          {
            id: '/collection/genres/48',
            title: 'Праздничная',
          },
          {
            id: '/collection/genres/47',
            title: 'Современная классика',
          },
          {
            id: '/collection/genres/46',
            title: 'Фанк',
          },
          {
            id: '/collection/genres/14',
            title: 'Шансон',
          },
          {
            id: '/collection/genres/105',
            title: 'Хард-рок',
          },
          {
            id: '/collection/genres/10',
            title: 'Металл',
          },
          {
            id: '/collection/genres/102',
            title: 'Фолк-рок',
          },
          {
            id: '/collection/genres/3',
            title: 'Рэп и хип-хоп',
          },
          {
            id: '/collection/genres/181',
            title: 'Аудиокниги на иностранном языке',
          },
          {
            id: '/collection/genres/44',
            title: 'Хардкор',
          },
          {
            id: '/collection/genres/68',
            title: 'Кельтская',
          },
          {
            id: '/collection/genres/25',
            title: 'Ска',
          },
          {
            id: '/collection/genres/78',
            title: 'Местное',
          },
          {
            id: '/collection/genres/34',
            title: 'Индастриал',
          },
          {
            id: '/collection/genres/106',
            title: 'K-pop',
          },
          {
            id: '/collection/genres/29',
            title: 'Дабстеп',
          },
          {
            id: '/collection/genres/158',
            title: 'Звуки природы и шум города',
          },
          {
            id: '/collection/genres/65',
            title: 'Мюзиклы',
          },
          {
            id: '/collection/genres/56',
            title: 'Даб',
          },
          {
            id: '/collection/genres/60',
            title: 'R&B и Урбан',
          },
          {
            id: '/collection/genres/69',
            title: 'Балканская',
          },
          {
            id: '/collection/genres/21',
            title: 'Авторская песня',
          },
          {
            id: '/collection/genres/79',
            title: 'Русская',
          },
          {
            id: '/collection/genres/49',
            title: 'New Wave',
          },
          {
            id: '/collection/genres/93',
            title: 'Ню-метал',
          },
          {
            id: '/collection/genres/96',
            title: 'Эпический',
          },
          {
            id: '/collection/genres/91',
            title: 'Для детей',
          },
          {
            id: '/collection/genres/100',
            title: 'Пост-хардкор',
          },
          {
            id: '/collection/genres/83',
            title: 'Из сериалов',
          },
          {
            id: '/collection/genres/201',
            title: 'Вокальный джаз',
          },
          {
            id: '/collection/genres/200',
            title: 'Бибоп',
          },
          {
            id: '/collection/genres/95',
            title: 'Прогрессив',
          },
          {
            id: '/collection/genres/74',
            title: 'Еврейская',
          },
          {
            id: '/collection/genres/103',
            title: 'Аргентинское танго',
          },
          {
            id: '/collection/genres/171',
            title: 'Шедевры мировой классики',
          },
          {
            id: '/collection/genres/154',
            title: 'J-pop',
          },
          {
            id: '/collection/genres/85',
            title: 'Из видеоигр',
          },
          {
            id: '/collection/genres/80',
            title: 'Пост-рок',
          },
          {
            id: '/collection/genres/184',
            title: 'Фантастика',
          },
          {
            id: '/collection/genres/22',
            title: 'Диско',
          },
          {
            id: '/collection/genres/89',
            title: 'Кавказская',
          },
          {
            id: '/collection/genres/84',
            title: 'Из мультфильмов',
          },
          {
            id: '/collection/genres/164',
            title: 'Художественная литература',
          },
          {
            id: '/collection/genres/67',
            title: 'Русская',
          },
          {
            id: '/collection/genres/90',
            title: 'Аудиосказки',
          },
          {
            id: '/collection/genres/113',
            title: 'Узбекская поп-музыка',
          },
          {
            id: '/collection/genres/38',
            title: 'Болливуд',
          },
          {
            id: '/collection/genres/94',
            title: 'Фолк',
          },
          {
            id: '/collection/genres/159',
            title: 'Аудиокниги',
          },
          {
            id: '/collection/genres/216',
            title: 'Фолк',
          },
          {
            id: '/collection/genres/86',
            title: 'Татарская',
          },
          {
            id: '/collection/genres/77',
            title: 'Украинский рок',
          },
          {
            id: '/collection/genres/104',
            title: 'Стоунер-рок',
          },
          {
            id: '/collection/genres/209',
            title: 'Фонк',
          },
          {
            id: '/collection/genres/111',
            title: 'Турецкий рэп и хип-хоп',
          },
          {
            id: '/collection/genres/174',
            title: 'Аниме',
          },
          {
            id: '/collection/genres/187',
            title: 'Детективы и ужасы',
          },
          {
            id: '/collection/genres/185',
            title: 'Фэнтези',
          },
          {
            id: '/collection/genres/152',
            title: 'Армянская музыка',
          },
          {
            id: '/collection/genres/210',
            title: 'Детская литература',
          },
          {
            id: '/collection/genres/202',
            title: 'Смус-джаз',
          },
          {
            id: '/collection/genres/109',
            title: 'Турецкая поп-музыка',
          },
          {
            id: '/collection/genres/81',
            title: 'Романсы',
          },
          {
            id: '/collection/genres/169',
            title: 'Турецкая классическая музыка',
          },
          {
            id: '/collection/genres/172',
            title: 'Турецкая народная музыка',
          },
          {
            id: '/collection/genres/182',
            title: 'Любовные романы',
          },
          {
            id: '/collection/genres/196',
            title: 'Дэт-метал',
          },
          {
            id: '/collection/genres/197',
            title: 'Блэк-метал',
          },
          {
            id: '/collection/genres/186',
            title: 'Приключения и экшн',
          },
          {
            id: '/collection/genres/170',
            title: 'Арабеска',
          },
          {
            id: '/collection/genres/178',
            title: 'О психологии и философии',
          },
          {
            id: '/collection/genres/112',
            title: 'Израильский рэп и хип-хоп',
          },
          {
            id: '/collection/genres/183',
            title: 'Исторические романы',
          },
          {
            id: '/collection/genres/203',
            title: 'Биг бэнды',
          },
          {
            id: '/collection/genres/168',
            title: 'Израильский рок',
          },
          {
            id: '/collection/genres/151',
            title: 'Азербайджанская музыка',
          },
          {
            id: '/collection/genres/192',
            title: 'Металкор',
          },
          {
            id: '/collection/genres/179',
            title: 'O духовном',
          },
          {
            id: '/collection/genres/155',
            title: 'Турецкий рок',
          },
          {
            id: '/collection/genres/175',
            title: 'На английском',
          },
          {
            id: '/collection/genres/165',
            title: 'Саморазвитие',
          },
          {
            id: '/collection/genres/221',
            title: 'Исламская музыка',
          },
          {
            id: '/collection/genres/180',
            title: 'Биографии и мемуары',
          },
          {
            id: '/collection/genres/153',
            title: 'Грузинская музыка',
          },
          {
            id: '/collection/genres/110',
            title: 'Турецкая альтернативная музыка',
          },
          {
            id: '/collection/genres/167',
            title: 'Израильская поп-музыка',
          },
          {
            id: '/collection/genres/189',
            title: 'Готический',
          },
          {
            id: '/collection/genres/208',
            title: 'Гиперпоп',
          },
          {
            id: '/collection/genres/195',
            title: 'Трэш-метал',
          },
          {
            id: '/collection/genres/217',
            title: 'Арабский поп',
          },
          {
            id: '/collection/genres/198',
            title: 'Дум-метал',
          },
          {
            id: '/collection/genres/199',
            title: 'Альтернативный метал',
          },
          {
            id: '/collection/genres/173',
            title: 'Азербайджанская поп-музыка',
          },
          {
            id: '/collection/genres/193',
            title: 'Брейкбит',
          },
          {
            id: '/collection/genres/212',
            title: 'EDM',
          },
          {
            id: '/collection/genres/166',
            title: 'Стихи для детей ',
          },
          {
            id: '/collection/genres/190',
            title: 'Сладж',
          },
          {
            id: '/collection/genres/176',
            title: 'Нон-фикшн',
          },
          {
            id: '/collection/genres/207',
            title: 'Бейс',
          },
          {
            id: '/collection/genres/191',
            title: 'Пост-метал',
          },
          {
            id: '/collection/genres/211',
            title: 'Трип-хоп',
          },
          {
            id: '/collection/genres/206',
            title: 'IDM',
          },
          {
            id: '/collection/genres/219',
            title: 'Египетский поп',
          },
          {
            id: '/collection/genres/161',
            title: 'Бизнес',
          },
          {
            id: '/collection/genres/204',
            title: 'Ужасы и триллеры',
          },
          {
            id: '/collection/genres/213',
            title: 'Пост-панк',
          },
          {
            id: '/collection/genres/205',
            title: 'UK Garage',
          },
          {
            id: '/collection/genres/188',
            title: 'Драма',
          },
          {
            id: '/collection/genres/163',
            title: 'Семья и общество',
          },
          {
            id: '/collection/genres/218',
            title: 'Халиджи',
          },
          {
            id: '/collection/genres/215',
            title: 'Мизрахи',
          },
          {
            id: '/collection/genres/222',
            title: 'Арабский рэп и хип-хоп',
          },
          {
            id: '/collection/genres/177',
            title: 'Популярно о науке',
          },
          {
            id: '/collection/genres/220',
            title: 'Шейлят',
          },
          {
            id: '/collection/genres/160',
            title: 'ЗОЖ',
          },
          {
            id: '/collection/genres/214',
            title: 'Колыбельные',
          },
          {
            id: '/collection/genres/157',
            title: 'Рок',
          },
          {
            id: '/collection/genres/223',
            title: 'Поэзия',
          },
          {
            id: '/collection/genres/114',
            title: 'Классическая музыка',
          },
          {
            id: '/collection/genres/162',
            title: 'Технологии',
          },
        ],
      },
    }
  },
  // mounted() {
  //   const playerjs = document.createElement('script')
  //   playerjs.src = `/static_files/playerjs-25.js`

  //   const topPlayer = document.querySelector('.top-player')

  //   if (topPlayer) {

  //     topPlayer.appendChild(playerjs)

  //   }
  // },
  beforeDestroy() {
  },
  methods: {
    setTop(val) {
      this.topMenuCat = val
    },
    async logout() {
      await this.$axios.get('/api/auth/logout')
      // this.$store.commit('setUser', null)
      location.reload()
    },
  }
}
</script>
